export const PRE_SIGNAL_QUERY = 'q';
export const TAGS_QUERY = 'tags';
export const LIVE_MASTER_CLASS_QUERY = 'livemasterclass';
export const MASTER_CLASS_EMBED_CODE_QUERY = 'masterClassEmbedCode';
